<template>
  <footer class="audit-footer">
    <span class="copyright">Copyright DONG-A SOCIO HOLIDINGS. All right reserved.</span>
  </footer>
</template>
<script>
export default {
  name: 'AdminFooter'
}
</script>
<style lang="scss" scoped>
.audit-footer{
  display:flex;
  background:#e6e6e6;
  padding:20px;
  flex-direction: column;
  text-align: center;
  margin-left:156px;
  padding:42px 0;
  .copyright{
    font-size:12px;
    line-height:21px;
    font-style: normal;
    font-weight: bold;
    color:#686868;
    flex:1;
    font-size:20px;
    font-weight: normal;
    line-height:1.425;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminFooter.vue